"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollDataFeedT = exports.PollDataFeed = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const data_feed_config_js_1 = require("../../solarxr-protocol/data-feed/data-feed-config.js");
/**
 * Requests for a single `Update` to be sent. This is helpful when getting
 * initial info about the device.
 */
class PollDataFeed {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsPollDataFeed(bb, obj) {
        return (obj || new PollDataFeed()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsPollDataFeed(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new PollDataFeed()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    config(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new data_feed_config_js_1.DataFeedConfig()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startPollDataFeed(builder) {
        builder.startObject(1);
    }
    static addConfig(builder, configOffset) {
        builder.addFieldOffset(0, configOffset, 0);
    }
    static endPollDataFeed(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createPollDataFeed(builder, configOffset) {
        PollDataFeed.startPollDataFeed(builder);
        PollDataFeed.addConfig(builder, configOffset);
        return PollDataFeed.endPollDataFeed(builder);
    }
    unpack() {
        return new PollDataFeedT((this.config() !== null ? this.config().unpack() : null));
    }
    unpackTo(_o) {
        _o.config = (this.config() !== null ? this.config().unpack() : null);
    }
}
exports.PollDataFeed = PollDataFeed;
class PollDataFeedT {
    constructor(config = null) {
        this.config = config;
    }
    pack(builder) {
        const config = (this.config !== null ? this.config.pack(builder) : 0);
        return PollDataFeed.createPollDataFeed(builder, config);
    }
}
exports.PollDataFeedT = PollDataFeedT;
